export function disagreeEmail(representative, bill, address) { 
  return `SUBJECT: Opposition to ${bill.billIdNumber} - ${bill.fullTitle} \n
Dear ${representative.fullName}: \n
My name is [Your Name], and I am a constituent from ${address}. I’m writing to let you know that I do not support ${bill.billIdNumber} - ${bill.title}. I believe this bill could cause problems within ${bill.category}.
${bill.opposition} Let's focus on finding better ways to solve this problem and work on a plan that helps everyone.
I hope you will think about my concerns and vote against this bill. Thank you for representing our community and for listening to my opinion.

Sincerely,
[Your Full Name]`;
}

export function agreeEmail(representative, bill, address) { 
  return `SUBJECT: Support for ${bill.billIdNumber} - ${bill.fullTitle}\n
Dear ${representative.fullName}:\n
My name is [Your Name], and I am a constituent from ${address}. I’m writing to let you know that I support ${bill.billIdNumber} - ${bill.title}. I believe this bill is important because it will help with ${bill.category}.
${bill.support}
I hope you will support this bill and help it move forward. Thank you for representing our community and for listening to my opinion.

Sincerely,\n
[Your Full Name]`;
}